/**
 * One live notification surfaced as a transient toast.
 *
 * The toast is a pure presentation payload: it never carries the source
 * notification row. The component that owns the notification list
 * (`MessagesComponent`) builds it, and handles the click through
 * `NotificationToastService.activated$` so read-state and routing stay in a
 * single place.
 */
export interface NotificationToast {
    /** Source notification id - also the identity of the toast in the stack. */
    id: string;
    /** Headline. Already resolved from title/body by the caller. */
    title: string;
    /** Optional secondary line; omitted when it would repeat the title. */
    body?: string;
    /** `mat-icon` svgIcon name from `getNotificationModuleIcon()`. */
    icon: string;
    /** Badge surface class from `getNotificationModuleIcon()`. */
    iconBgClass: string;
    /** Badge glyph class from `getNotificationModuleIcon()`. */
    iconTextClass: string;
    /** True when activating the toast routes somewhere (renders the View affordance). */
    actionable: boolean;
    /** Auto-dismiss delay in ms. */
    duration: number;
}

/**
 * Default time a toast stays on screen. Long enough to read two lines and
 * reach for it, short enough that it never feels like a permanent banner.
 * The countdown pauses while the toast is hovered or focused.
 */
export const NOTIFICATION_TOAST_DURATION = 8000;
